import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import {
  FEEDBACK_QUERY,
  parseStartWorkFlag,
} from "../feedback-url";

export function useFeedbackDrawerUrl() {
  const [searchParams, setSearchParams] = useSearchParams();

  const ticketUuid = searchParams.get(FEEDBACK_QUERY.UUID);
  const startWork = useMemo(
    () =>
      parseStartWorkFlag(
        searchParams.get(FEEDBACK_QUERY.START_WORK),
        searchParams.get(FEEDBACK_QUERY.START_WORK_LEGACY),
      ),
    [searchParams],
  );

  const openTicket = useCallback(
    (uuid: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set(FEEDBACK_QUERY.UUID, uuid);
          next.delete(FEEDBACK_QUERY.START_WORK);
          next.delete(FEEDBACK_QUERY.START_WORK_LEGACY);
          return next;
        },
        { replace: false },
      );
    },
    [setSearchParams],
  );

  const closeTicket = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(FEEDBACK_QUERY.UUID);
        next.delete(FEEDBACK_QUERY.START_WORK);
        next.delete(FEEDBACK_QUERY.START_WORK_LEGACY);
        return next;
      },
      { replace: true },
    );
  }, [setSearchParams]);

  const clearStartWorkParam = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(FEEDBACK_QUERY.START_WORK);
        next.delete(FEEDBACK_QUERY.START_WORK_LEGACY);
        return next;
      },
      { replace: true },
    );
  }, [setSearchParams]);

  return {
    ticketUuid,
    startWork,
    openTicket,
    closeTicket,
    clearStartWorkParam,
  };
}
